import React from 'react';
import styled from 'styled-components';

const StyledDiv = styled('div')`
  && {
    color: #616161;
    border: solid 1px #0C4376;
    border-radius: 8px;
    padding: 10px;
    background: #0C43760D;
    width: 100%;
  }
`;

export function IconInfo(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1.5em"
      width="1.5em"
      {...props}
    >
      <path d="M22 12 A10 10 0 0 1 12 22 A10 10 0 0 1 2 12 A10 10 0 0 1 22 12 z" />
      <path d="M12 16v-4M12 8h.01" />
    </svg>
  );
}

const InfoAlert = ({children}) => (
  <StyledDiv>
    &nbsp;
    <IconInfo style={{verticalAlign: 'text-bottom'}} />
    <b style={{position: 'relative', top: '-2px'}}>
      &nbsp; {children}
    </b>
  </StyledDiv>
);

export default InfoAlert;
